<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '因子'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="110px" :rules="rules">
      <el-row :gutter="10">
        <!-- <el-col :span="12">
          <el-form-item label="因子ID" prop="FactorID">
            <el-input-number
              v-model="item.FactorID"
              style="width: 100%"
              controls-position="right"
              placeholder="请输入因子ID"
              :min="1"
              :disabled="1"
            ></el-input-number>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="因子名称" prop="Name">
            <el-input
              v-model.trim="item.Name"
              placeholder="因子名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="简称" prop="ShortName">
            <el-input
              v-model.trim="item.ShortName"
              placeholder="因子简称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="212编码" prop="Code">
            <el-input v-model.trim="item.Code" placeholder="212编码"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="因子分组" prop="FactorGroup">
            <el-input
              v-model.trim="item.FactorGroup"
              placeholder="因子分组"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="英文名称" prop="EnglishName">
            <el-input
              v-model.trim="item.EnglishName"
              placeholder="英文名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="化学符号学号" prop="CASNumber">
            <el-input
              v-model.trim="item.CASNumber"
              placeholder="化学符号学号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="10">
         <el-col :span="12">
          <el-form-item label="化学符号" prop="ChemicalSymbol">
            <el-input
              v-model.trim="item.ChemicalSymbol"
              placeholder="化学符号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="HTML简称" prop="ShortNameHTML">
            <el-input
              v-model.trim="item.ShortNameHTML"
              placeholder="因子HTML简称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="HTML全称" prop="FullNameHTML">
            <el-input
              v-model.trim="item.FullNameHTML"
              placeholder="因子HTML全称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="计量单位组" prop="MeasureUnitGroupID">
            <select2
              style="width: 100%"
              v-model="item.MeasureUnitGroupID"
              url="basic?type=MeasureUnitGroup"
              :clearable="false"
              placeholder="请选择计量单位"
              :emptyValue="0"
              :currentList="currentMeasureUnitGroup"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计量单位" prop="MeasureUnitID">
            <select2
              style="width: 100%"
              v-model="item.MeasureUnitID"
              :url="measureUnitUrl"
              placeholder="请选择计量单位"
              :disabled="!item.MeasureUnitGroupID"
              :emptyValue="0"
              :currentList="currentMeasureUnit"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="因子类型" prop="IpcFactorTypeID">
            <select2
              style="width: 100%"
              v-model="item.IpcFactorTypeID"
              url="basic?type=businesstype"
              :clearable="false"
              placeholder="请选择因子分类"
              :emptyValue="0"
              :currentList="currentIpcFactorType"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="指标类型" prop="IpcCategoryID">
            <select2
              style="width: 100%"
              v-model="item.IpcCategoryID"
              url="basic?type=category"
              :clearable="false"
              placeholder="请选择指标类型"
              :emptyValue="0"
              :currentList="currentIpcCategory"
              :queryOne="false"
            ></select2>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="缺省数据类型" prop="DefaultDataType">
            <el-input
              v-model.trim="item.DefaultDataType"
              placeholder="缺省数据类型，如：N4.2"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否使用" prop="IsUseOrNot">
            <el-switch v-model="item.IsUseOrNot"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="排序值" prop="OrderByNum">
            <el-input-number
              v-model="item.OrderByNum"
              :min="0"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否API计算" prop="IsCalAPIOrNot">
            <el-switch v-model="item.IsCalAPIOrNot"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注" prop="Note">
        <el-input
          v-model.trim="item.Note"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    isEdit: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      item: {},
      measureUnitUrl: "",
      form: {
        GroupID: "",
        "Name:like": "",
        "Code:like": "",
      },
      rules: {
        FactorID: [
          { required: true, message: "因子ID不能为空", trigger: "blur" },
        ],
        Name: [
          { required: true, message: "因子名称不能为空", trigger: "blur" },
        ],
        Code: [{ required: true, message: "212编码不能为空", trigger: "blur" }],
        IpcFactorTypeID: [
          { required: true, message: "因子类型不能为空", trigger: "blur" },
        ],
        MeasureUnitGroupID: [
          { required: true, message: "计量单位组不能为空", trigger: "blur" },
        ],
        MeasureUnitID: [
          { required: true, message: "计量单位不能为空", trigger: "blur" },
        ],
        DefaultDataType: [
          { required: true, message: "缺省数据类型不能为空", trigger: "blur" },
          {
            pattern: /N\d+\.\d*$/,
            message: "格式不正确,如：N4.2",
            trigger: "blur",
          },
        ],
      },
      submitting: false,
      currentMeasureUnitGroup: [],
      currentMeasureUnit: [],
      currentIpcFactorType: [],
      currentIpcCategory: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    "item.MeasureUnitGroupID": {
      handler() {
        this.measureUnitUrl = `measureunit?where[GroupID]=${this.item.MeasureUnitGroupID}`;
      },
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      if (this.value.ID) {
        if (this.value.MeasureUnitGroup) {
          this.currentMeasureUnitGroup = [
            //计量单位组
            {
              ID: this.value.MeasureUnitGroupID,
              Name: this.value.MeasureUnitGroup.Name,
            },
          ];
        }
        if (this.value.MeasureUnit) {
          this.currentMeasureUnit = [
            //计量单位
            { ID: this.value.MeasureUnitID, Name: this.value.MeasureUnit.Name },
          ];
        }
        if (this.value.IpcFactorType) {
          this.currentIpcFactorType = [
            //因子类型
            {
              ID: this.value.IpcFactorTypeID,
              Name: this.value.IpcFactorType.Name,
            },
          ];
        }
        if (this.value.IpcCategory) {
          this.currentIpcCategory = [
            //指标类型
            { ID: this.value.IpcCategoryID, Name: this.value.IpcCategory.Name },
          ];
        }
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();

      this.currentMeasureUnitGroup = [];
      this.currentMeasureUnit = [];
      this.currentIpcFactorType = [];
      this.currentIpcCategory = [];
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };

        // 保存的操作
        this.$axios
          .request({
            url: this.isEdit ? `ipcfactor/${itemData.ID}` : "ipcfactor",
            method: this.isEdit ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(this.isEdit ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(this.isEdit ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(this.isEdit ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
